import { observable } from 'mobx'
import { MESSAGE_TYPE_DEFAULT, MESSAGE_TYPE_VOICE } from 'core/constants'

export default class Message {
  @observable id

  constructor(data) {
    this.id = data.id
    this.sentBy = data.sentBy
    this.senderUid = data.senderUid
    this.receiverUid = data.receiverUid
    this.userUid = data.userUid
    this.sentAt = data.sentAt
    this.type = data.type || MESSAGE_TYPE_DEFAULT
    this.replay = data.replay
    this.receiver = data.receiver //TODO temporary fix for message-service flaw
    this.hidden = data.hidden
    this.duration = data.duration || 0

    if (data.type === MESSAGE_TYPE_VOICE && data.message) {
      try {
        const parsed = JSON.parse(data.message)
        this.message = parsed.voice || data.message
        this.voiceText = parsed.text || ''
      } catch {
        this.message = data.message
      }
    } else {
      this.message = data.message || ''
    }
  }
}
